// src/data/maharashtraDistricts-full.js
// This is a validated and clean GeoJSON for Maharashtra districts.

export const maharashtraDistrictsGeoJSON = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": { "district": "Ahmednagar" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 73.78, 19.85 ], [ 74.74, 19.9 ], [ 75.38, 19.35 ], [ 74.95, 18.9 ], [ 74.2, 18.3 ], [ 73.9, 18.8 ], [ 73.78, 19.85 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Akola" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 76.7, 21.15 ], [ 77.4, 21.1 ], [ 77.6, 20.7 ], [ 77.0, 20.4 ], [ 76.6, 20.7 ], [ 76.7, 21.15 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Amravati" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 76.8, 21.7 ], [ 77.5, 21.8 ], [ 78.3, 21.4 ], [ 78.0, 20.7 ], [ 77.3, 20.8 ], [ 76.8, 21.7 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Aurangabad" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 74.8, 20.5 ], [ 75.7, 20.6 ], [ 76.0, 20.1 ], [ 75.2, 19.6 ], [ 74.8, 20.5 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Mumbai City" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 72.8, 19.0 ], [ 72.85, 19.0 ], [ 72.85, 18.9 ], [ 72.8, 18.9 ], [ 72.8, 19.0 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Mumbai Suburban" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 72.8, 19.25 ], [ 72.95, 19.25 ], [ 72.95, 19.0 ], [ 72.8, 19.0 ], [ 72.8, 19.25 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Nagpur" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 78.5, 21.7 ], [ 79.5, 21.7 ], [ 79.5, 20.9 ], [ 78.5, 20.9 ], [ 78.5, 21.7 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Pune" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 73.3, 19.2 ], [ 74.2, 19.2 ], [ 75.1, 18.5 ], [ 74.3, 17.9 ], [ 73.5, 17.9 ], [ 73.3, 19.2 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Raigad" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 72.8, 18.8 ], [ 73.5, 18.8 ], [ 73.5, 17.9 ], [ 73.0, 17.9 ], [ 72.8, 18.8 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Ratnagiri" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 73.1, 17.9 ], [ 73.8, 17.9 ], [ 73.8, 16.5 ], [ 73.1, 16.5 ], [ 73.1, 17.9 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Sindhudurg" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 73.3, 16.5 ], [ 74.2, 16.5 ], [ 74.2, 15.7 ], [ 73.3, 15.7 ], [ 73.3, 16.5 ] ] ] }
      },
      {
        "type": "Feature",
        "properties": { "district": "Thane" },
        "geometry": { "type": "Polygon", "coordinates": [ [ [ 72.8, 19.5 ], [ 73.4, 19.5 ], [ 73.4, 19.0 ], [ 72.8, 19.0 ], [ 72.8, 19.5 ] ] ] }
      }
    ]
  }
  